export default {
    meta: {
        title: '鱼你在一起-店铺评估',
        url: '/fishtogether/storeassess',
        urlName: '鱼你店铺评估'
    }
};
